import { Box, Dialog, DialogActions, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 8px;
    border: ${(p) => `1px solid ${p.theme.palette.grey[300]}`};
    box-shadow: none;
  }
`;

export const Header = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: ${(p) => p.theme.spacing(6)};
  border-bottom: 1px solid ${(p) => p.theme.palette.grey[300]} !important;
  padding: ${(p) => p.theme.spacing(1.5)};
  background-color: ${(p) => p.theme.palette.common.white} !important;
  font-size: ${(p) => p.theme.typography.body2.fontSize} !important;
  font-weight: ${(p) => p.theme.typography.fontWeightSemiBold} !important;
  color: ${(p) => p.theme.palette.grey[800]} !important;
`;

export const Title = styled(Box)`
  padding: 0;
  display: flex;
  width: 100%;
`;

export const Content = styled(Box)``;

export const Actions = styled(DialogActions)`
  border-top: 1px solid transparent;
  padding-top: ${(p) => p.theme.spacing(2)};
  gap: ${(p) => p.theme.spacing(1)};

  > * {
    margin: 0 !important;
  }
`;

export const SubTitle = styled(Typography)`
  font-size: 14px;
`;
